(function (CFShipsIn24Hours) {
  const initPPDMods = () => {
    (function CF24f() {
      function addContent() {
        console.log('CF24 init...');
        let section = $('.component.inline-cart');
        if (section.length == 0) {
          setTimeout(addContent, 100);
          return;
        }

        //what element to observe
        const targetNode = document.querySelectorAll('.inline-cart')[0];

        const config = {
          attributes: true,
          childList: true,
          subtree: true,
        };

        const callback = function () {
          let sideCart = $('.component.inline-cart');

          if (!sideCart.hasClass('is-active')) {
            return;
          } else {
            if ($('.view-cart p').text().indexOf('empty') > -1) {
              return;
            } else {
              if ($('.cf24-shipping').length < 1) {
                $('.view-cart').before(
                  `<div class='cf24-shipping'>Ships within<span class='cf-hours'>&nbsp;24 Hours</span></div>`
                );
              } else {
                return;
              }
            }
          }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
      }

      $(document).ready(function () {
        addContent();
      });
    })();
  };

  const listenForLoaded = () => {
    addEventListener('DOMContentLoaded', (event) => {
      initPPDMods();
    });
  };

  // Public / Init
  CFShipsIn24Hours.init = function () {
    listenForLoaded();
  };
})((window.CFShipsIn24Hours = window.CFShipsIn24Hours || {}), jQuery);